import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { Response, PaginateResponse } from 'app/model';
import {
    WellSchematicCdft,
    WellSchematicDiagram,
} from 'app/modules/well-schematic-diagram/model';
import { WellSchematicDiagramState } from 'app/modules/well-schematic-diagram/state/well-schematic-diagram.state';

@Injectable({ providedIn: 'root' })
export class WellSchematicDiagramService {
    constructor(
        private readonly _httpClient: HttpClient,
        private readonly state: WellSchematicDiagramState
    ) { }

    getWellConfigList(
        params: any
    ): Observable<Response<PaginateResponse<WellSchematicDiagram>>> {
        const url = composeUrl(`/v1/Wellbarrier/wellConfigList`, params);
        return this._httpClient
            .get<Response<PaginateResponse<WellSchematicDiagram>>>(url)
            .pipe(
                take(1),
                this.state.resolveStore((response) => {
                    return { records: response.data.data };
                })
            );
    }

    updateWellConfigList(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/wellConfig`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    saveWellConfig(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/configs`);
        return this._httpClient.post<Response<any>>(url, payload).pipe(take(1));
    }

    saveApplicationStatus(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/wellSchematicApplication`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    updateWellConfig(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/configs`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    getAllConfig(
        params: any = {}
    ): Observable<Response<PaginateResponse<any>>> {
        const url = composeUrl(`/v1/Wellbarrier/configs`, params);
        return this._httpClient
            .get<Response<PaginateResponse<any>>>(url)
            .pipe(take(1));
    }

    deleteWellConfig(id: string): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/configs/${id}`);
        return this._httpClient.delete<Response<any>>(url).pipe(take(1));
    }

    // getWellSchematicById(id: string): Observable<Response<any>> {
    //     const url = composeUrl(`/v1/Wellbarrier/getWellSchematicById/${id}`);
    //     return this._httpClient.get<Response<any>>(url).pipe(take(1));
    // }

    assignSchematic(
        wellStringId: string,
        id: string
    ): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/assignWellSchematic`);
        return this._httpClient
            .post<Response<any>>(url, { wellStringId, id })
            .pipe(take(1));
    }

    duplicateSchematic(
        wellStringId: string,
        payload: any
    ): Observable<Response<any>> {
        const url = composeUrl(
            `/v1/Wellbarrier/duplicateWellSchematic/${wellStringId}`
        );
        return this._httpClient.post<Response<any>>(url, payload).pipe(take(1));
    }

    getCdftSchematic(
        wellStringId: string
    ): Observable<Response<WellSchematicCdft[]>> {
        const url = composeUrl(`/v1/Wellbarrier/cdftPreview/${wellStringId}`);
        return this._httpClient
            .get<Response<WellSchematicCdft[]>>(url)
            .pipe(take(1));
    }

    getConfigurationHistory(wellStringId: string): Observable<Response<any[]>> {
        const url = composeUrl(
            `/v1/Wellbarrier/configurationHistory/${wellStringId}`
        );
        return this._httpClient.get<Response<any[]>>(url).pipe(take(1));
    }


    getWellSchematicByWellString(params: {
        wellStringId: string;
        isApplication: string;
    }): Observable<Response<any>> {
        const url = composeUrl(
            `/v1/Wellbarrier/getWellSchematicByWellString`,
            params
        );
        return this._httpClient.get<Response<any>>(url).pipe(take(1));
    }

    downloadExcel() {
        const url = composeUrl(
            `/v1/Wellbarrier/DownloadOverallWellSchematicConfigList`
        );
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `well-schematic.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }

    updateMonitoring(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/updateMonitoring`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    submitWellSchematicByString(payload: any): Observable<Response<any>> {
        const url = composeUrl(`/v1/Wellbarrier/AssignSchematicForWellString`);
        return this._httpClient.put<Response<any>>(url, payload).pipe(take(1));
    }

    aprGaugeMeter(wellStringId: string): Observable<Response<any>> {
        const params = { wellStringId: wellStringId }
        const url = composeUrl(
            `/v1/WBS/DashboardWbs/overview/well-barrier-diagram/apr-gauge-meter`,
            params
        );
        return this._httpClient.get<Response<any>>(url).pipe(take(1));
    }

    aprMawopGaugeMeter(wellStringId: string): Observable<Response<any>> {
        const params = { wellStringId: wellStringId }
        const url = composeUrl(
            `/v1/WBS/DashboardWbs/overview/well-barrier-diagram/apr-mawop-gauge-meter`,
            params
        );
        return this._httpClient.get<Response<any>>(url).pipe(take(1));
    }
}
